import { useEffect, useState, useRef } from "react";
import "./login.css";
import "../App.css";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Alert, FormControl, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  getTokenID,
  isEmployerLogin,
  permissionStatus,
  role,
} from "../redux/modules/userSlice";
import Snackbar from "@mui/material/Snackbar";
import Cookies from "js-cookie";
import { PermissionsStatusManage } from "../constants/defaultValue";

// const baseURL = process.env.REACT_APP_BASEURL;

const defaultTheme = createTheme();

const Login = () => {
  const nav = useNavigate();
  const otpRefs = useRef([]);
  const dispatch = useDispatch();
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  // const [emailError, setEmailError] = useState("");
  // const [passwordError, setPasswordError] = useState("");
  // const [openSnackbar, setOpenSnackbar] = useState(false);
  // const [snackbarMessage, setSnackbarMessage] = useState("");
  // const [showPassword, setShowPassword] = useState(false);

  const [state, setState] = useState({
    email: "",
    password: "",
    emailError: "",
    passwordError: "",
    isOtpStep: false,
    snackbar: {
      open: false,
      message: "",
      severity: "error",
    },
    showPassword: false,
    LoadingSpinner: false,
  });

  const [otp, setOtp] = useState(Array(6).fill(""));

  // const isEmployer = useSelector((state) => state.user.isEmployer);
  // const roles = useSelector((state) => state.user.role);

  // useEffect(() => {
  //   const token = Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref");
  //   if (token) {
  //     // User is already logged in, redirect to another route

  //     if (role === "EMPLOYER") {
  //       nav('/mydashboard');
  //     }
  //     else if (role === "TAMANAGER" || role === "ADMIN") {
  //       nav('/jobOrders?page=1');
  //     }
  //     else {
  //       nav('/jobOrders?page=1');
  //     }
  //   }
  // }, [nav]);

  // const handleSnackbarOpen = (message) => {
  //   setSnackbarMessage(message);
  //   setOpenSnackbar(true);
  // };

  // const handleSnackbarClose = (event, reason) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }
  //   setOpenSnackbar(false);
  // };

  const handleSubmit = (event) => {
    event.preventDefault();
    let isValid = true;

    if (!emailRegex.test(state.email)) {
      updateState("emailError", "Invalid email format");
      isValid = false;
      updateSnackbar("Invalid email format", "error");
    } else {
      updateState("emailError", "");
    }

    if (!state.password) {
      updateState("passwordError", "Password Required");
      isValid = false;
    } else {
      updateState("passwordError", "");
    }

    if (isValid) {
      axios
        .post(
          `user/login`,
          { email: state.email, password: state.password },
          { withCredentials: true },
        )
        .then((response) => {
          updateState("isOtpStep", true);
          updateSnackbar("OTP sent successfully", "success");

          // const d = new Date();
          // d.setTime(d.getTime() + 2 * 24 * 60 * 60 * 1000);
          // let expires = "expires=" + d.toUTCString();
          // document.cookie =
          //   "_secure_ARJ_" +
          //   "=" +
          //   response.data.message.token +
          //   ";" +
          //   expires +
          //   ";path=/";
          // dispatch(getTokenID(response.data.message.token));
          // localStorage.setItem("token", response.data.message.token);
          // localStorage.setItem("email_id", response.data.message.user.email);
          // localStorage.setItem("username", response.data.message.user.name);
          // localStorage.setItem("logo", response.data.message.logo);
          // localStorage.setItem("user_id", response.data.message.user.user_id);
          // dispatch(permissionStatus(response.data.message.manage_permissions));
          // dispatch(isEmployerLogin(response.data.message.isEmployer));
          // dispatch(role(response.data.message.role));
          // updateSnackbar("Login Successful", "success");
          // if (response?.data?.message?.role === "SEO") {
          //   nav("/blogs");
          // } else {
          //   nav("/mydashboard");
          // }
        })
        .catch((err) => {
          updateState("passwordError", err.response.data.error);
          updateSnackbar(err.response.data.error, "error");
        });
    }
  };

  const handleOtpVerify = async () => {
    if (otp.join("").length !== 6) {
      updateSnackbar("Please enter a valid 6-digit OTP", "error");
      return;
    }

    try {
      axios
        .post(
          `user/verify-otp`,
          { email: state.email, otp: otp.join("") },
          { withCredentials: true },
        )
        .then((response) => {
          const d = new Date();
          d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
          let expires = "expires=" + d.toUTCString();
          document.cookie =
            "_secure_ARJ_" +
            "=" +
            response.data.message.token +
            ";" +
            expires +
            ";path=/";
          dispatch(getTokenID(response.data.message.token));
          localStorage.setItem("token", response.data.message.token);
          localStorage.setItem("email_id", response.data.message.user.email);
          localStorage.setItem(
            "username",
            response.data.message.user.user_name,
          );
          localStorage.setItem(
            "name",
            response?.data?.message?.user?.first_name +
              " " +
              response?.data?.message?.user?.last_name,
          );
          localStorage.setItem("logo", response.data.message.logo);
          localStorage.setItem("user_id", response.data.message.user.user_id);
          dispatch(permissionStatus(response.data.message.manage_permissions));
          dispatch(isEmployerLogin(response.data.message.isEmployer));
          dispatch(role(response.data.message.role));
          updateSnackbar("Login Successful", "success");
          if (response?.data?.message?.role === "SEO") {
            nav("/blogs");
          } else {
            nav("/mydashboard");
          }
        })
        .catch((err) => {
          updateState("passwordError", err.response.data.error);
          updateSnackbar(err.response.data.error, "error");
        });
    } catch (error) {
      updateSnackbar("Invalid OTP", "error");
    }
  };

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 5) {
        otpRefs.current[index + 1].focus();
      }
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);

      if (index > 0) {
        otpRefs.current[index - 1].focus();
      }
    } else if (e.key === "Enter" && index === 5) {
      handleOtpVerify();
    }
  };

  const updateState = (field, value) => {
    setState((prev) => ({ ...prev, [field]: value }));
  };

  const updateSnackbar = (message, severity = "error") => {
    setState((prev) => ({
      ...prev,
      snackbar: { open: true, message, severity },
    }));
  };

  const handleSnackbarClose = () => {
    setState((prev) => ({
      ...prev,
      snackbar: { ...prev.snackbar, open: false },
    }));
  };

  const handleClickShowPassword = () => {
    updateState("showPassword", !state.showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (state.isOtpStep) {
      otpRefs.current[0]?.focus();
    }
  }, [state.isOtpStep]);

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="sm">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 15,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src="https://jobeze.com/logo/EmployerPortalLogo.svg"
            className="LoginJobezeLogo"
            alt="Employer Portal"
          />
        </Box>
        <Box
          sx={{
            marginTop: 5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "20px",
            borderRadius: "16px",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20);",
          }}
        >
          <Typography component="h1" sx={{ my: 2 }} variant="h4">
            {state.isOtpStep ? "Verify OTP" : "Login"}
          </Typography>
          {state.isOtpStep ? (
            <>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={5}
                sx={{ mb: 3 }}
              >
                {[...Array(6)].map((_, index) => (
                  <TextField
                    key={index}
                    id={`otp-input-${index}`}
                    inputRef={(ref) => (otpRefs.current[index] = ref)}
                    inputProps={{
                      maxLength: 1,
                      style: { textAlign: "center" },
                    }}
                    value={otp[index] || ""}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleOtpKeyDown(e, index)}
                    variant="outlined"
                    size="small"
                    sx={{ width: "40px" }}
                  />
                ))}
              </Box>
              <Button
                onClick={handleOtpVerify}
                fullWidth
                size="large"
                variant="contained"
                sx={{ py: 1 }}
              >
                Submit
              </Button>
            </>
          ) : (
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                // margin="dense"
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                onFocus={(e) => updateState("emailError", "")}
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                autoFocus
                autoComplete="email"
                value={state.email}
                onChange={(e) => updateState("email", e.target.value)}
                error={!!state.emailError}
                helperText={state.emailError}
              />
              <FormControl fullWidth sx={{ mt: 2 }} variant="outlined">
                <TextField
                  type={state.showPassword ? "text" : "password"}
                  value={state.password}
                  size="small"
                  variant="outlined"
                  onChange={(e) => updateState("password", e.target.value)}
                  onFocus={(e) => updateState("passwordError", "")}
                  label="Password"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {state.showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={!!state.passwordError}
                  helperText={state.passwordError ? state.passwordError : ""}
                />
              </FormControl>

              <Grid container sx={{ mt: 2 }}>
                <Grid item xs>
                  <Link
                    href="/forgetpassword"
                    sx={{
                      cursor: "pointer",
                      textDecoration: "none",
                      letterSpacing: "1px",
                    }}
                    variant="body2"
                  >
                    Forgot password?
                  </Link>
                </Grid>
              </Grid>
              <Button
                type="submit"
                fullWidth
                size="large"
                variant="contained"
                sx={{ mt: 3, mb: 2, py: 1 }}
                // disabled={password.length <= 0}
              >
                Log In
              </Button>
            </Box>
          )}
        </Box>
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={state.snackbar.open}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={state.snackbar.severity}
            sx={{ width: "100%" }}
          >
            {state.snackbar.message}
          </Alert>
        </Snackbar>
      </Container>
    </ThemeProvider>
  );
};

export default Login;
